import { Account } from '~/lib/ApiModel';
import { IApiClient } from '~/lib/ApiClient';
import { AsyncStore } from './AsyncStore';
import { makeObservable, observable, runInAction } from 'mobx';

const adminIndicatorSuffix = '&admin';

export class AccountStore extends AsyncStore<Account, undefined> {
    @observable
    isAdminLogin = false;

    constructor(public apiClient: IApiClient) {
        super(() => this.loadAccount(), undefined);
        makeObservable(this);
    }

    async loadAccount(): Promise<Account> {
        const acc = await this.apiClient.getAccount();

        // We indicate an admin login by adding a &admin suffix to the returned email. We strip it off before setting the store item and toggle the isAdminLogin prop
        if (acc.email.endsWith(adminIndicatorSuffix)) {
            acc.email = acc.email.substring(0, acc.email.length - adminIndicatorSuffix.length);
            runInAction(() => (this.isAdminLogin = true));
        } else {
            runInAction(() => (this.isAdminLogin = false));
        }
        return acc;
    }
}
